import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
export const FieldSorterService = Symbol('FieldSorterService');
let FieldSorterServiceImpl = class FieldSorterServiceImpl {
    constructor() {
        this._fields = [];
    }
    setSortedFields(fields) {
        this._fields = [...fields];
    }
    getSortedFields() {
        return [...this._fields];
    }
};
FieldSorterServiceImpl = __decorate([
    injectable()
], FieldSorterServiceImpl);
export { FieldSorterServiceImpl };
